export default {"src":"/_next/static/media/ONON.5811bc7a.svg","height":18,"width":18};